<template>
    <div class="select-trading-account">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="400px" class="demo-ruleForm">
            <el-form-item label="Choose Trading Account Type :" prop="trade_account_type">
                <el-select v-model="ruleForm.trade_account_type" placeholder="Please Select" style="width:350px;">
                    <el-option :value="Number(key)" :label="val" v-for="(val,key) in trade_account_type"></el-option>
                </el-select>
                <span class="label-details" @click="dialogTableVisible = true">Details</span>
            </el-form-item>

            <el-form-item label="Initial Leverage :" prop="initial_leverage">
                <el-select v-model="ruleForm.initial_leverage" placeholder="Please Select" style="width:350px;">
                    <el-option :value="Number(key)" :label="val" v-for="(val,key) in initial_leverage"></el-option>
                </el-select>
                <p style="width:350px;line-height:20px;margin-top:10px;">Note: Your chosen Trading Account leverage only
                    applies to your FX trades, other instruments you trade may have their
                    respective leverages that apply to them. For more information please refer to product
                    specification.</p>
            </el-form-item>

            <el-form-item label="Trading Account Base Currency Required :" prop="trade_account_currency">
                <el-select v-model="ruleForm.trade_account_currency" placeholder="Please Select" style="width:350px;">
                    <el-option :value="Number(key)" :label="val"
                               v-for="(val,key) in trade_account_currency"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')" :loading="btn_loading" class="box-btn"
                           style="width: 221px;">NEXT
                </el-button>
            </el-form-item>

        </el-form>

        <el-dialog :visible.sync="dialogTableVisible">
            <div class="dialogTable">
                <table width="90%" class="ac-table">
                    <thead>
                    <tr>
                        <th>
                            Items
                        </th>
                        <th>
                            Zeal Standard Trading Account
                        </th>
                        <th>
                            Zeal ECN Trading Account
                        </th>
                    </tr>
                    </thead>
                    <tr>
                        <td>Minimum Spread</td>
                        <td>Please refer to <a target="_block" :href="product_specification_url"> Product
                            Specification.</a></td>
                        <td>Please refer to <a target="_block" :href="product_specification_url"> Product
                            Specification.</a></td>
                    </tr>
                    <tr>
                        <td>Trading Products</td>
                        <td>FX, Commodities, Global Indices and Cryptocurrencies</td>
                        <td>FX, Commodities, Global Indices and Cryptocurrencies</td>
                    </tr>
                    <tr>
                        <td>Minimum Deposit</td>
                        <td>1,000 USD (or equivalent)</td>
                        <td>5,000 USD (or equivalent)</td>
                    </tr>
                    <tr>
                        <td>Maximum Leverage</td>
                        <td>1:100</td>
                        <td>1:100</td>
                    </tr>
                    <tr>
                        <td>Commission</td>
                        <td>None</td>
                        <td>Yes,Please refer to <a target="_block" :href="product_specification_url"> Product
                            Specification.</a></td>
                    </tr>
                    <tr>
                        <td>Trading Platform</td>
                        <td>Zeal MT4 (for PC, Mac, Android and iOS)</td>
                        <td>Zeal MT4 (for PC, Mac, Android and iOS)</td>
                    </tr>
                </table>
            </div>
        </el-dialog>

    </div>
</template>

<script>
  import * as server from '../action'

  export default {
    data () {
      return {
        trade_account_type: {},
        initial_leverage: {},
        trade_account_currency: {},
        dialogTableVisible: false,
        product_specification_url: 'http://www.zfx.co.uk/products/index',
        ruleForm: {
          trade_account_type: '',
          initial_leverage: '',
          trade_account_currency: '',
        },
        rules: {
          trade_account_type: [
            {required: true, message: 'Please Select', trigger: 'change'}
          ],
          initial_leverage: [
            {required: true, message: 'Please Select', trigger: 'change'}
          ],
          trade_account_currency: [
            {required: true, message: 'Please Select', trigger: 'change'}
          ]
        },
        btn_loading: false,
        encrypt: {}
      }
    },
    created () {
      var str = location.href
      console.log(str)
      if (str.search('stb') != -1) {
        this.product_specification_url =
          'http://www2.stb.zfx.co.uk/products/index'
      }
      if (str.search('beta') != -1) {
        this.product_specification_url =
          'http://www2.beta.zfx.co.uk/products/index'
      }
      server
        .certification_apply_index({step: 1})
        .then(({fieldOptions, setting}) => {
          /* get option val */
          this.trade_account_type = fieldOptions.trade_account_type
          this.initial_leverage = fieldOptions.initial_leverage
          this.trade_account_currency = fieldOptions.trade_account_currency
          /* set option default val */

          Object.keys(this.ruleForm).map((val, key) => {
            this.ruleForm[val] = Number(setting[val]) || ''
          })
        })
    },
    methods: {
      submitForm (formName) {
        this.btn_loading = true
        this.$refs[formName].validate(valid => {
          if (valid) {
            let params = {
              step: 1,
              initial_leverage: this.ruleForm.initial_leverage,
              trade_account_currency: this.ruleForm.trade_account_currency,
              trade_account_type: this.ruleForm.trade_account_type
            }
            server
              .certification_apply_save(params)
              .then(res => {
                this.$emit('onStopIndex', 2)
                this.btn_loading = false
              })
              .catch(err => {
                this.btn_loading = false
              })
          } else {
            this.btn_loading = false
            console.log('error submit!!')
            return false
          }
        })
      },
      resetForm (formName) {
        this.$refs[formName].resetFields()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .select-trading-account {
        .label-details {
            padding-left: 10px;
            text-decoration: underline;
            color: #367adf;
            cursor: pointer;
        }
        .dialogTable {
            padding: 0 60px 30px;
            .ac-table {
                thead {
                    background-color: #fff;
                }
                td,
                th {
                    line-height: 18px;
                    font-size: 14px;
                }
                th {
                    font-size: 14px;
                    font-weight: bold;
                    font-stretch: normal;
                    line-height: 24px;
                    letter-spacing: 0px;
                    color: #0A95FF;
                }
                td {
                    a {
                        color: #367adf;
                        text-decoration: underline;
                    }
                }
            }
        }
    }
</style>
